import { SHOW_LOADER, HIDE_LOADER, } from "../action/Action";

const initialState = {
    loading: false,
}

const loadingActionReducer = (state = initialState, action) => {
    switch (action?.type) {
        case SHOW_LOADER:
            return {
                ...state,
                loading: true
            };
        case HIDE_LOADER:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export default loadingActionReducer;